<!--
 * @Author: katty 15032801667@163.com
 * @Date: 2022-12-02 09:55:15
 * @LastEditors: katty 15032801667@163.com
 * @LastEditTime: 2022-12-21 10:23:16
 * @FilePath: \epec-ea\src\modules\projectA\pages\approve\enquireApprove\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <approve-list :title="title" :type="flag" :key="flag"></approve-list>
  </div>
</template>

<script>
  import ApproveList from '../component/approveList'
export default {
  name: 'enquireApprove',

  components: {
    ApproveList
  },
  data() {
    return {
      title:'询比价审批',
      flag:5
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>